import { App } from './app/App';
import { createRoot } from 'react-dom/client';
import { setGlobalTheme } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
import './assets/css/charlie-fonts.css';

setGlobalTheme({
  colorMode: 'light',
  typography: 'typography-adg3',
});

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(<App />);
